var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4 13.0001C23.4 18.7439 18.7437 23.4001 13 23.4001C7.25621 23.4001 2.59998 18.7439 2.59998 13.0001C2.59998 7.25634 7.25621 2.6001 13 2.6001C18.7437 2.6001 23.4 7.25634 23.4 13.0001ZM14.3 7.8001C14.3 8.51807 13.7179 9.1001 13 9.1001C12.282 9.1001 11.7 8.51807 11.7 7.8001C11.7 7.08213 12.282 6.5001 13 6.5001C13.7179 6.5001 14.3 7.08213 14.3 7.8001ZM11.7 11.7001C10.982 11.7001 10.4 12.2821 10.4 13.0001C10.4 13.7181 10.982 14.3001 11.7 14.3001V18.2001C11.7 18.9181 12.282 19.5001 13 19.5001H14.3C15.0179 19.5001 15.6 18.9181 15.6 18.2001C15.6 17.4821 15.0179 16.9001 14.3 16.9001V13.0001C14.3 12.2821 13.7179 11.7001 13 11.7001H11.7Z",
    fill: "#3A50C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoToastIcon);
export default __webpack_public_path__ + "static/media/InfoToastIcon.0d19992a46a2dfa2efedccab6f413717.svg";
export { ForwardRef as ReactComponent };